import { render, staticRenderFns } from "./DashboardVisitasNuser.vue?vue&type=template&id=53c833c3&scoped=true"
import script from "./DashboardVisitasNuser.vue?vue&type=script&lang=js"
export * from "./DashboardVisitasNuser.vue?vue&type=script&lang=js"
import style0 from "./DashboardVisitasNuser.vue?vue&type=style&index=0&id=53c833c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c833c3",
  null
  
)

export default component.exports